/* inno-cart-add.js — one way into the bag, for every surface that has one.

   The product page's form, the sticky buy bar and the lattice's quick-add all go through
   window.innoAddToCart, so the rules live in one place rather than in three copies that drift.

   There is one rule today, and it exists because this shop sells one-of-ones: a piece already in
   the bag cannot be added again. Shopify will happily take a second of anything whose inventory
   isn't tracked, and a duplicate line on a single garment is a refund waiting to happen. The
   check is by PRODUCT, not by variant — two sizes of one piece is not a thing that exists here,
   and "you already have this" is the sentence the visitor needs either way.

   It is a courtesy, not a security control: the real guarantee is inventory tracking in Shopify,
   which is what stops a second order being taken if someone gets past this. */
(function () {
  'use strict';

  var toastEl = null, toastT = null;

  function css() {
    if (document.getElementById('inno-cart-add-css')) return;
    var s = document.createElement('style');
    s.id = 'inno-cart-add-css';
    s.textContent =
      '.inno-toast{position:fixed;left:50%;bottom:calc(26px + env(safe-area-inset-bottom,0px));' +
        'transform:translate(-50%,14px);z-index:10000;pointer-events:none;max-width:88vw;' +
        'font-family:var(--mono,"IBM Plex Mono",ui-monospace,SFMono-Regular,Menlo,monospace);' +
        'font-size:11px;letter-spacing:.22em;text-transform:uppercase;white-space:nowrap;' +
        'color:var(--bone,#E8E4DC);background:rgba(10,10,10,.88);' +
        '-webkit-backdrop-filter:blur(12px) saturate(0);backdrop-filter:blur(12px) saturate(0);' +
        'border:1px solid rgba(232,228,220,.22);padding:13px 20px;' +
        'opacity:0;transition:opacity .28s ease,transform .28s cubic-bezier(.22,1,.36,1);}' +
      '.inno-toast.on{opacity:1;transform:translate(-50%,0);}' +
      '@media (prefers-reduced-motion:reduce){.inno-toast{transition:opacity .2s ease;' +
        'transform:translate(-50%,0);}}';
    (document.head || document.documentElement).appendChild(s);
  }

  function toast(msg) {
    css();
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'inno-toast';
      toastEl.setAttribute('role', 'status');
      (document.body || document.documentElement).appendChild(toastEl);
    }
    toastEl.textContent = '[ ' + msg + ' ]';
    // a second message replaces the first rather than queueing behind it — the newer one is
    // always the one that answers what the visitor just did
    clearTimeout(toastT);
    void toastEl.offsetWidth;
    toastEl.classList.add('on');
    toastT = setTimeout(function () { if (toastEl) toastEl.classList.remove('on'); }, 2600);
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function paintCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
    document.querySelectorAll('.cart-count-bubble span,[id*="cart-icon-bubble"] .cart-count-bubble')
      .forEach(function (el) { if (el) el.textContent = n; });
  }

  /* Resolves to { added, reason }. Never rejects: every caller is a button, and a button that
     throws leaves its label stuck on "Adding…". */
  window.innoAddToCart = function (opts) {
    opts = opts || {};
    var id = opts.id == null ? '' : String(opts.id);
    var pid = opts.productId == null ? null : String(opts.productId);
    if (!window.fetch) return Promise.resolve({ added: false, reason: 'nofetch' });
    if (!id) return Promise.resolve({ added: false, reason: 'noid' });

    return getCart().then(function (c) {
      var items = (c && c.items) || [];
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (String(it.variant_id) === id || (pid !== null && String(it.product_id) === pid)) {
          toast('Already in your bag');
          // show them the bag rather than only telling them — the piece is in there, and the
          // fastest way to believe it is to see the line
          if (window.innoOpenCart) window.innoOpenCart();
          return { added: false, reason: 'duplicate' };
        }
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      }).then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, d: d }; });
      }).then(function (res) {
        if (!res.ok) throw res.d;
        return getCart().then(function (c2) {
          document.dispatchEvent(new CustomEvent('inno:cart:updated', { detail: c2 }));
          paintCount(c2.item_count);
          if (window.innoOpenCart) window.innoOpenCart();
          return { added: true, cart: c2 };
        });
      }).catch(function (err) {
        toast((err && err.description) || 'Unavailable');
        return { added: false, reason: 'error' };
      });
    }).catch(function () {
      toast('Unavailable');
      return { added: false, reason: 'error' };
    });
  };

  window.innoToast = toast;      // the same readout, for anything else that needs to say something
})();
